import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Grid,
  Card,
  CardContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Stack,
  Alert,
  CircularProgress,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { 
  Videocam as VideocamIcon,
  CheckCircle as CheckIcon,
  Business as BusinessIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Person as PersonIcon
} from '@mui/icons-material';
import LandingLayout from '../../components/LandingLayout';
import landingTheme from '../../theme/landingTheme';

const DemoRequestPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    companyName: '',
    structureType: '',
    residentsCount: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simula invio form
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 2000);
  };

  const benefits = [
    'Demo personalizzata della piattaforma',
    'Consulenza gratuita sulle tue esigenze',
    'Analisi del tuo processo attuale',
    'Piano di migrazione personalizzato',
    'Q&A con esperti del settore',
    'Preventivo su misura senza impegno'
  ];

  if (submitted) {
    return (
      <LandingLayout>
        <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, landingTheme.colors.primary 0%, landingTheme.colors.primaryLight 100%)' }}>
          <Container maxWidth="md" sx={{ pt: 10, pb: 6 }}>
          <Card sx={{ 
            p: 6, 
            textAlign: 'center',
            bgcolor: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(10px)'
          }}>
            <CheckIcon sx={{ fontSize: 100, color: '#4caf50', mb: 3 }} />
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 2 }}>
              Richiesta Inviata con Successo! ✓
            </Typography>
            <Typography variant="h6" sx={{ color: '#666', mb: 4, lineHeight: 1.7 }}>
              Grazie per il tuo interesse! Il nostro team ti contatterà entro 24 ore 
              per fissare una demo personalizzata al numero <strong>{formData.phone}</strong> o 
              via email a <strong>{formData.email}</strong>.
            </Typography>
            <Alert severity="info" sx={{ mb: 4, textAlign: 'left' }}>
              <strong>Cosa Aspettarti:</strong>
              <ul style={{ marginTop: 8, marginBottom: 0 }}>
                <li>Chiamata di conferma entro 24h lavorative</li>
                <li>Demo online di 30-45 minuti</li>
                <li>Consulenza gratuita personalizzata</li>
                <li>Preventivo dettagliato senza impegno</li>
              </ul>
            </Alert>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ justifyContent: 'center' }}>
              <Button 
                variant="contained" 
                size="large"
                onClick={() => navigate('/')}
                sx={{ fontWeight: 700 }}
              >
                Torna alla Home
              </Button>
              <Button 
                variant="outlined"
                size="large"
                onClick={() => navigate('/register')}
                sx={{ fontWeight: 700 }}
              >
                Inizia Prova Gratuita
              </Button>
            </Stack>
          </Card>
        </Container>
        </Box>
      </LandingLayout>
    );
  }

  return (
    <LandingLayout>
      <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, landingTheme.colors.primary 0%, landingTheme.colors.primaryLight 100%)' }}>
        <Container maxWidth="lg" sx={{ pt: 6, pb: 6 }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Chip 
            label="DEMO GRATUITA" 
            sx={{ 
              bgcolor: 'rgba(255,255,255,0.2)', 
              color: 'white', 
              fontWeight: 700,
              mb: 3,
              px: 2,
              py: 0.5,
              border: '1px solid rgba(255,255,255,0.3)'
            }} 
          />
          <Typography 
            variant="h2" 
            sx={{ 
              fontWeight: 800,
              color: 'white',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              mb: 3
            }}
          >
            Vedi Gestionale Anziani in Azione
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              color: 'rgba(255,255,255,0.9)',
              textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
              fontWeight: 400,
              maxWidth: '800px',
              mx: 'auto',
              lineHeight: 1.6
            }}
          >
            Prenota una demo personalizzata di 30 minuti con uno dei nostri esperti. 
            Ti mostreremo come il nostro gestionale può trasformare la tua struttura.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {/* Form Column */}
          <Grid item xs={12} md={7}>
            <Card sx={{ 
              p: 4,
              bgcolor: 'rgba(255,255,255,0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: '#1a1a1a' }}>
                Compila il Form di Richiesta
              </Typography>
              
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      name="fullName"
                      label="Nome e Cognome"
                      value={formData.fullName}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <PersonIcon sx={{ mr: 1, color: '#666' }} />
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      type="email"
                      name="email"
                      label="Email"
                      value={formData.email}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <EmailIcon sx={{ mr: 1, color: '#666' }} />
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      name="phone"
                      label="Telefono"
                      value={formData.phone}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <PhoneIcon sx={{ mr: 1, color: '#666' }} />
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      name="companyName"
                      label="Nome Struttura"
                      value={formData.companyName}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <BusinessIcon sx={{ mr: 1, color: '#666' }} />
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Tipo Struttura</InputLabel>
                      <Select
                        name="structureType"
                        value={formData.structureType}
                        onChange={handleChange}
                        label="Tipo Struttura"
                      >
                        <MenuItem value="casa_riposo">Casa di Riposo</MenuItem>
                        <MenuItem value="rsa">RSA</MenuItem>
                        <MenuItem value="comunita_alloggio">Comunità Alloggio</MenuItem>
                        <MenuItem value="residenza_sanitaria">Residenza Sanitaria</MenuItem>
                        <MenuItem value="altro">Altro</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Numero Residenti</InputLabel>
                      <Select
                        name="residentsCount"
                        value={formData.residentsCount}
                        onChange={handleChange}
                        label="Numero Residenti"
                      >
                        <MenuItem value="1-20">1-20</MenuItem>
                        <MenuItem value="21-50">21-50</MenuItem>
                        <MenuItem value="51-100">51-100</MenuItem>
                        <MenuItem value="100+">Oltre 100</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      name="message"
                      label="Note o Richieste Specifiche (Opzionale)"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Raccontaci le tue esigenze o domande specifiche..."
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button 
                      type="submit"
                      variant="contained" 
                      size="large"
                      fullWidth
                      disabled={loading}
                      startIcon={loading ? <CircularProgress size={20} /> : <VideocamIcon />}
                      sx={{ 
                        py: 1.5,
                        fontWeight: 700,
                        fontSize: '1.1rem'
                      }}
                    >
                      {loading ? 'Invio in corso...' : 'Richiedi Demo Gratuita'}
                    </Button>
                  </Grid>
                </Grid>
              </form>

              <Alert severity="info" sx={{ mt: 3 }}>
                <strong>Privacy:</strong> I tuoi dati saranno utilizzati solo per contattarti 
                per la demo richiesta e non saranno condivisi con terze parti.
              </Alert>
            </Card>
          </Grid>

          {/* Benefits Column */}
          <Grid item xs={12} md={5}>
            <Card sx={{ 
              p: 4,
              mb: 3,
              bgcolor: 'rgba(255,255,255,0.15)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.3)'
            }}>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: 'white', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
                Cosa Include la Demo
              </Typography>
              
              <Stack spacing={2}>
                {benefits.map((benefit, index) => (
                  <Box key={index} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <CheckIcon sx={{ color: '#4caf50', fontSize: 24, mt: 0.5, filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.3))' }} />
                    <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.95)', fontWeight: 500, lineHeight: 1.6 }}>
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Card>

            <Card sx={{ 
              p: 4,
              bgcolor: 'rgba(255,255,255,0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a1a1a' }}>
                📞 Preferisci Parlare con Noi?
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', mb: 2, lineHeight: 1.7 }}>
                Il nostro team è disponibile Lun-Ven 9:00-13:00 e 15:00-19:00
              </Typography>
              <Stack spacing={1.5}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PhoneIcon sx={{ color: landingTheme.colors.primary }} />
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#1a1a1a' }}>
                    (+39) 379 248 9784
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <EmailIcon sx={{ color: landingTheme.colors.primary }} />
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#1a1a1a' }}>
                    info@reaktice.com
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Testimonials */}
        <Box sx={{ mt: 8 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, textAlign: 'center', mb: 4, color: 'white', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
            Cosa Dicono i Nostri Clienti
          </Typography>
          
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, height: '100%', bgcolor: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(10px)' }}>
                <Typography variant="body1" sx={{ color: '#666', mb: 2, fontStyle: 'italic', lineHeight: 1.7 }}>
                  "La demo è stata illuminante. In 30 minuti abbiamo capito come risparmiare ore 
                  di lavoro ogni settimana. Ci siamo iscritti subito!"
                </Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: landingTheme.colors.primary }}>
                  - Maria Rossi, Direttrice Casa di Riposo Villa Serena
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, height: '100%', bgcolor: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(10px)' }}>
                <Typography variant="body1" sx={{ color: '#666', mb: 2, fontStyle: 'italic', lineHeight: 1.7 }}>
                  "Il consulente ha capito subito le nostre esigenze e ci ha mostrato 
                  esattamente le funzioni che cercavamo. Professionali e preparati."
                </Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: landingTheme.colors.primary }}>
                  - Giuseppe Bianchi, Responsabile RSA San Giuseppe
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, height: '100%', bgcolor: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(10px)' }}>
                <Typography variant="body1" sx={{ color: '#666', mb: 2, fontStyle: 'italic', lineHeight: 1.7 }}>
                  "Demo molto dettagliata, hanno risposto a tutte le nostre domande. 
                  Abbiamo visto subito il potenziale per la nostra struttura."
                </Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: landingTheme.colors.primary }}>
                  - Laura Verdi, Coordinatrice Residenza Aurora
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>
      </Box>
    </LandingLayout>
  );
};

export default DemoRequestPage;
